import { MGButton, SearchInput } from "../../../components";

// Third party
import { FaFileInvoiceDollar } from "react-icons/fa6";

import { ExportInvoiceCSV } from "./ExportInvoiceCSV";

// Style
import "./GenerateInvoice.scss";

export const GenerateInvoiceToolbar = ({
  rows,
  rowsToExport,
  handleGenerate,
  isSelecteItemForGenerate,
  searchParams,
  handleSearchParam,
  isSubmitting,
}: any) => {
  return (
    <div className="generate-invoice-toolbar">
      {rows && rows.length > 0 && (
        <>
          {!!handleSearchParam && (
            <SearchInput
              className="search-field"
              placeholder="Search crew id..."
              value={searchParams}
              onChange={handleSearchParam}
            />
          )}
          <div style={{display: "flex", gap: 16}}>
          {/* <MGButton
            className="model-button"
            onClick={handleGenerate}
            disabled={isSelecteItemForGenerate || isSubmitting}
          >
            <FaFileInvoiceDollar className="dollar-icon" />
            {isSubmitting ? "Generating..." : "Generate"}
          </MGButton> */}

          <ExportInvoiceCSV rows={rowsToExport ?? rows} />
          </div>
        </>
      )}
    </div>
  );
};
